import styled, { css } from 'styled-components';

interface WidthProps {
  width?: number;
}

interface BorderProps {
  borderSuccessLength?: number;
}

interface ActiveProps {
  isActive?: boolean;
}

interface InvalidProps {
  invalid?: boolean;
}

type ContentProps = WidthProps & BorderProps & InvalidProps;

const ActiveLabelCSS = css`
  transform: translate(-2px, -26px);
  background-color: #ffffff;
  font-size: 14px;
`;

export const Content = styled.div<ContentProps>`
  display: flex;
  max-width: ${({ width }) => width || 385}px;
  position: relative;
  background: #fff;
  border-radius: 4px;
  border: 1px solid ${({ invalid }) => (invalid ? 'red' : '#cccccc')};
  padding: 15px 20px;
  color: gray;

  align-items: center;

  &:before {
    content: '';
    position: absolute;
    left: 2px;
    bottom: -1px;
    height: 1px;
    border-bottom: 4px solid green;
    border-radius: 5px;
    max-width: 100%;

    ${(props) => {
      const length = props.borderSuccessLength || 0;
      const width = length * 20;

      if (width >= 100) {
        return css`
          width: ${width}%;
          padding: 6px;
          left: 0;
        `;
      }

      return css`
        width: ${width}%;
      `;
    }}
  }

  &:focus-within label {
    ${ActiveLabelCSS}
  }

  &.full {
    width: 100%;
  }

  input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    width: 94px;
    font-size: 15px;

    &::placeholder {
      color: gray;
    }

    & + input {
      margin-top: 8px;
    }
  }

  p {
    font-size: 15px;
    color: black;
    transition: 0.3s;
  }

  svg {
    height: 20px;
    width: 20px;
    color: #737373;
  }

  @media (max-width: 768px) {
    max-width: none;
  } ;
`;

export const Label = styled.label<ActiveProps>`
  font-size: 15px;
  font-family: 'Roboto', sans-serif;
  padding: 0 5px;
  pointer-events: none;
  position: absolute;
  font-weight: 400;
  color: #737373;
  transition: all 100ms linear;

  ${({ isActive }) => isActive && ActiveLabelCSS}
`;
